import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { auth } from '../firebase';
import {
  fetchUserRole,
  resolveAdminPanelAccess,
} from '../services/adminAuthService';
import './AdminLogin.css';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/admin';

  useEffect(() => {
    if (location.state?.denied) {
      setError('You do not have admin access. Contact the conference team.');
    }
  }, [location.state?.denied]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const credential = await signInWithEmailAndPassword(
        auth,
        email.trim(),
        password
      );
      const role = await fetchUserRole(credential.user.uid);
      const access = resolveAdminPanelAccess(role);

      if (access === 'admin') {
        navigate(from, { replace: true });
        return;
      }

      await signOut(auth);

      if (access === 'usher') {
        setError(
          'This account is for scan portal access only. Use the conference scan login instead.'
        );
        return;
      }

      setError('You do not have admin access. Contact the conference team.');
    } catch (err) {
      setError(err.message || 'Sign in failed. Check your email and password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-card">
          <div className="admin-login-header">
            <h1>Admin Access</h1>
            <p>Tanzania Dental Association Conference 2026</p>
            <p className="admin-login-subtitle">Sign in with your admin account</p>
          </div>

          {error && <div className="admin-login-error">{error}</div>}

          <form onSubmit={handleSubmit} className="admin-login-form">
            <div className="form-group">
              <label htmlFor="admin-email">Email</label>
              <input
                type="email"
                id="admin-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="your.name@tdaevents.or.tz"
                autoComplete="username"
              />
            </div>

            <div className="form-group">
              <label htmlFor="admin-password">Password</label>
              <input
                type="password"
                id="admin-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter your password"
                autoComplete="current-password"
              />
            </div>

            <button type="submit" className="btn-admin-login" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className="admin-login-footer">
            <p>41st TDA Scientific Conference &amp; AGM 2026</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
